import React, { Component } from 'react';

type ViewToggleProps = {
  onViewChange?: (view: 'grid' | 'list') => void;
};

type ViewToggleState = {
  view: 'grid' | 'list';
};

export default class ViewToggle extends Component<ViewToggleProps, ViewToggleState> {
  constructor(props: ViewToggleProps) {
    super(props);
    this.state = {
      view: 'grid',
    };
  }

  handleClick = (clickedView: 'grid' | 'list') => {
    this.setState({ view: clickedView }, () => {
      if (this.props.onViewChange) {
        this.props.onViewChange(this.state.view);
      }
    });
  };

  render() {
    const { view } = this.state;

    return (
      <div>
          {view === 'list' && (
            <button
              onClick={() => this.handleClick('grid')}
              style={{
                border: '1px solid',
                cursor: 'pointer',
                paddingLeft: '18px',
                paddingRight: '18px',
                paddingTop: '8px',
                paddingBottom: '8px',
                fontSize: '16px',
                transition: 'background-color 0.2s ease',
                backgroundColor: 'transparent',
                display: 'flex',          // horizontal layout
                flexDirection: 'row',     // default row, optional
                alignItems: 'center',     // vertically center icon and text
                gap: '8px',               // space between text and icon
              }}
            >

            <svg
             xmlns="http://www.w3.org/2000/svg"
             fill="none"
             viewBox="0 0 24 24"
             strokeWidth="1.5"
             stroke="currentColor"
             aria-hidden="true"
             width="20"
             height="20"
           >
             <path
               strokeLinecap="round"
               strokeLinejoin="round"
               d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z"
             />
           </svg>
              GridView
            </button>
          )}

          {view === 'grid' && (
            <button
              onClick={() => this.handleClick('list')}
              style={{
                border: '1px solid',
                cursor: 'pointer',
                paddingLeft: '18px',
                paddingRight: '18px',
                paddingTop: '8px',
                paddingBottom: '8px',
                fontSize: '16px',
                transition: 'background-color 0.2s ease',
                backgroundColor: 'transparent',
                display: 'flex',          // horizontal layout
                flexDirection: 'row',     // default row, optional
                alignItems: 'center',     // vertically center icon and text
                gap: '8px',               // space between text and icon
              }}
            >

            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              aria-hidden="true"
              width="20"
              height="20"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
              />
            </svg>
              ListView
            </button>
          )}
      </div>
    );
  }
}
